var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocsQna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#FFD174"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3887 19.464C15.4082 16.9835 16.1114 16.2218 17.3418 15.4601C18.1817 14.9327 18.8067 14.2687 18.8067 13.2921C18.8067 12.1984 17.9668 11.4952 16.8926 11.4952C15.916 11.4952 14.9785 12.1202 14.9199 13.4288H12.4785C12.5371 10.8116 14.5098 9.46399 16.9121 9.46399C19.5489 9.46399 21.3653 10.9288 21.3653 13.2531C21.3653 14.8351 20.5645 15.8702 19.2949 16.632C18.1621 17.3156 17.6934 17.9991 17.6739 19.464V19.6398H15.3887V19.464ZM16.5996 23.9562C15.7598 23.9562 15.0762 23.2726 15.0762 22.4327C15.0762 21.6124 15.7598 20.9288 16.5996 20.9288C17.4004 20.9288 18.1035 21.6124 18.1035 22.4327C18.1035 23.2726 17.4004 23.9562 16.5996 23.9562Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsQna);
export default __webpack_public_path__ + "static/media/docs_qna.9e8cf9aee5583699445edd7050119e5f.svg";
export { ForwardRef as ReactComponent };